import { IState } from '../../store';

export const selectOfferBookingLoading = (state: IState): boolean => state.newbuildingBrokerOfferBooking.loading;
